var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-5",
      staticStyle: {
        width: "calc(100% - 6rem)",
        "border-radius": "20px",
        height: "calc(100% - 6rem)",
      },
      attrs: { id: "app" },
    },
    [
      _vm.connected
        ? _c("left-panel", { attrs: { context: _vm.context } })
        : _vm._e(),
      _vm._v(" "),
      _vm.connected ? _c("right-panel") : _vm._e(),
      _vm._v(" "),
      _c(
        "f7-views",
        [
          _c(
            "f7-view",
            {
              staticClass: "bgToolbox",
              attrs: {
                domCache: false,
                uniqueHistory: false,
                id: "main-view",
                main: "",
                url: _vm.url,
              },
            },
            [
              _vm.connected && !_vm.isSmartphoneOS
                ? _c("web-header", {
                    key: "web-header-" + _vm.webheaderKey,
                    attrs: { context: _vm.context },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.connected
                ? _c("mobile-header", { attrs: { context: _vm.context } })
                : _vm._e(),
              _vm._v(" "),
              _c("f7-pages", {
                class: _vm.connected ? "marginHomepageLargeScreen" : "",
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("cm-popups"),
      _vm._v(" "),
      _c("user-guide"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }